<template>
  <div>
    <div class="tab1 cus-main-tabs">
      <v-card class="sm-mt-0 mt-6" v-if="allSlate.length > 0">
        <v-tabs
          v-model="tab"
          background-color="#32cd32"
          dark
          centered
          center-active
        >
          <v-tabs-slider color="#17408B"></v-tabs-slider>
          <!-- //? NBA.. -->
          <template v-if="defaultSport == '1'">
            <!-- tab-1 -->
            <v-tab exact :to="{ name: 'nbaPositionOpti' }">
              Position Optimizer
            </v-tab>
            <!-- tab 1 ends -->

            <!-- tab-2 -->
            <v-tab exact :to="{ name: 'nbaSavedLineup' }">
              Saved Lineups
            </v-tab>
            <!-- tab 2 ends -->
          </template>

          <!-- //? Mlb.. -->
          <template v-else-if="defaultSport == '2'">
            <!-- tab-1 -->
            <v-tab exact :to="{ name: 'MlbPositionOpti' }">
              Position Optimizer
            </v-tab>
            <!-- tab 1 ends -->

            <!-- tab-2 -->
            <v-tab :to="{ name: 'MlbSavedLineup' }" exact>
              Saved Lineups
            </v-tab>
            <!-- tab 2 ends -->
          </template>

          <!-- //?NHL.. -->
          <template v-else-if="defaultSport == '3'">
            <!-- tab-1 -->
            <v-tab exact :to="{ name: 'NhlPositionOpti' }">
              Position Optimizer
            </v-tab>
            <!-- tab 1 ends -->

            <!-- tab-2 -->
            <v-tab :to="{ name: 'NhlSavedLineup' }" exact>
              Saved Lineups
            </v-tab>
            <!-- tab 2 ends -->
          </template>

          <!-- //?NFL.. -->
          <template v-else-if="defaultSport == '4'">
            <!-- tab-1 -->
            <v-tab exact :to="{ name: 'NflPositionOpti' }">
              Position Optimizer
            </v-tab>
            <!-- tab 1 ends -->

            <!-- tab-2 -->
            <v-tab :to="{ name: 'NflSavedLineup' }" exact>
              Saved Lineups
            </v-tab>
            <!-- tab 2 ends -->
          </template>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <transition
            mode="out-in"
            enter-active-class="animate__animated animate__fadeInLeft animate__faster"
            leave-active-class="animate__animated animate__fadeOutRight animate__faster"
          >
            <router-view
              :allSlate="allSlate"
              :defaultSport="defaultSport"
              :defaultOptimizer="defaultOptimizer"
            ></router-view>
          </transition>
        </v-tabs-items>
      </v-card>

      <!-- # -->
      <div
        v-if="!slateStatus"
        style="background-color: #3eaf7c; min-height: 90vh"
      >
        <maintenance :defaultSport="defaultSport" />
      </div>
      <!-- # -->
    </div>
  </div>
</template>

<script>
import Maintenance from "@/components/maintenance.vue";
export default {
  name: "OptimizerTab",
  props: [
    "allSlate",
    "defaultSport",
    "defaultOptimizer",
    "slateStatus",
    "planType",
  ],
  components: {
    Maintenance,
  },
  data() {
    return {
      tab: null,
    };
  },
};
</script>
<style scoped>
@media (max-width: 415px) {
  .team-a {
    margin-left: 20px;
  }
  .team-b {
    margin-left: 20px;
  }
}
</style>
